import logo from "./logo.svg";
import "./App.css";
import "../src/css/style.css";
import "../src/css/responsive.css";
import { dispatchFn, naviagetFn } from "../src/common/navigator";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";

import "antd/dist/antd.css";
import RoutesNew from "./Route/Routes";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import {
  selectReferralCode,
  setCodeRef,
  setReferral,
} from "./redux/slices/referralSlice.slice";
import RootGate from "./Route/RootGate";
import { SimpleLoader } from "./components/SubscriptionnScreen/paymentSummary";

function App() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const referralCode = useSelector(selectReferralCode);

  useEffect(() => {
    const query = new URLSearchParams(window.location.search);
    const ref = query.get("ref");
    console.log("window.location.search", window.location.search);
    console.log("search:", location.search);

    if (ref) {
      dispatch(setCodeRef(ref));
      localStorage.setItem("ref_mode", "true");
    localStorage.setItem("token", null);

    }
  }, []);

  useEffect(() => {
    const handler = () => {
      if (window.tolt_referral) {
        console.log(window.tolt_referral, "second");
        dispatch(setReferral(window.tolt_referral));
      }
    };

    if (window.tolt_referral) {
      handler();
    }

    document.addEventListener("toltScriptLoaded", handler);

    return () => {
      document.removeEventListener("toltScriptLoaded", handler);
    };
  }, []);
  naviagetFn(navigate);
  dispatchFn(dispatch);
  return <RootGate />;
}

export default App;
